import React from 'react';
import { X } from 'lucide-react';
import { Badge } from '../../../../components/ui/Badge';
import { formatDate, formatPhone, decodeAddress } from '../utils/formatters';

export const WorkdayEmployeeDetailModal = ({ isOpen, onClose, employee }) => {
  if (!isOpen || !employee) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
      <div className="bg-gray-800 rounded-2xl border border-gray-700 shadow-xl w-full max-w-4xl max-h-[90vh] overflow-hidden flex flex-col">
        <div className="px-6 py-4 border-b border-gray-700 flex items-center justify-between">
          <h2 className="text-2xl font-semibold text-white">
            Detalles del Empleado de Workday
          </h2>
          <button
            type="button"
            onClick={onClose}
            className="p-2 rounded-lg hover:bg-gray-700 text-gray-400 hover:text-white transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-6">
          <div className="space-y-6">
            <div>
              <h3 className="text-lg font-semibold text-white mb-4">Información Personal</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-400 mb-1">WID</label>
                  <p className="text-white">{employee.WID || 'N/A'}</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-400 mb-1">Fábrica</label>
                  <p className="text-white">{employee.Factory || 'N/A'}</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-400 mb-1">Nombre</label>
                  <p className="text-white">{employee.FirstName || 'N/A'}</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-400 mb-1">Apellido</label>
                  <p className="text-white">{employee.LastName || 'N/A'}</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-400 mb-1">Email</label>
                  {employee.Email ? (
                    <a
                      href={`mailto:${employee.Email}`}
                      className="text-blue-400 hover:text-blue-300 hover:underline"
                    >
                      {employee.Email}
                    </a>
                  ) : (
                    <p className="text-gray-400">N/A</p>
                  )}
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-400 mb-1">Teléfono</label>
                  <p className="text-white">{formatPhone(employee.Phone)}</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-400 mb-1">Fecha de Contratación</label>
                  <p className="text-white">{formatDate(employee.HireDate)}</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-400 mb-1">Estado</label>
                  <Badge
                    className={
                      employee.Status
                        ? 'bg-emerald-900/50 text-emerald-200'
                        : 'bg-red-900/50 text-red-200'
                    }
                  >
                    {employee.Status ? 'Activo' : 'Inactivo'}
                  </Badge>
                </div>
              </div>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-white mb-4">Información Laboral</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-400 mb-1">Título</label>
                  <p className="text-white">{employee.BusinessTitle || 'N/A'}</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-400 mb-1">Perfil Trabajo</label>
                  <p className="text-white">{employee.JobProfileID || 'N/A'}</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-400 mb-1">ID Personal</label>
                  <p className="text-white">{employee.UserPersonalID || 'N/A'}</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-400 mb-1">Centro de Costos</label>
                  <p className="text-white">{employee.EmployeeCostCenter || 'N/A'}</p>
                </div>
              </div>
            </div>

            {employee.PathAddressData && (
              <div>
                <h3 className="text-lg font-semibold text-white mb-4">Dirección</h3>
                <div className="bg-gray-700 rounded-lg p-4">
                  <p className="text-white whitespace-pre-line">
                    {decodeAddress(employee.PathAddressData)}
                  </p>
                </div>
              </div>
            )}

            <div>
              <h3 className="text-lg font-semibold text-white mb-4">Fechas del Sistema</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-400 mb-1">Fecha de Creación</label>
                  <p className="text-white">{formatDate(employee.CreatedAt)}</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-400 mb-1">Última Actualización</label>
                  <p className="text-white">{formatDate(employee.UpdatedAt)}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="px-6 py-4 border-t border-gray-700 flex items-center justify-end">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 rounded-lg border border-gray-600 bg-gray-700 text-gray-300 text-sm font-medium hover:bg-gray-600 transition-colors"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};
